import { RefObject } from 'react';
import { ReferenceObject } from 'popper.js';

export interface PopoverAnchorCoords {
  x: number;
  y: number;
  width: number;
  height: number;
}

export type PopoverPlacement = 'left' | 'right';

export const getReferenceObject = (
  coords: PopoverAnchorCoords,
  popoverRef: RefObject<HTMLDivElement | null>,
  placement?: 'left' | 'right',
): ReferenceObject => {
  const { x, y, width, height } = coords;

  return {
    clientHeight: height,
    clientWidth: width,
    getBoundingClientRect: () => {
      return {
        height: height,
        width: width,
        x,
        y,
        bottom: y,
        left: x,
        right: placement === 'left' && popoverRef.current ? x - popoverRef.current.clientWidth - width / 2 : x + width,
        top: popoverRef.current ? y - 1.5 * popoverRef.current.clientHeight : y,
        toJSON: () => null,
      };
    },
  };
};
